module.exports = __webpack_public_path__ + "media/images/lb/460-3bb5df1dcbc6e82ede0574092e12e30a.svg";